"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorageClient = void 0;
const BaseClient_1 = require("../BaseClient");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class StorageClient extends BaseClient_1.BaseClient {
    constructor(entity, baseUrl, tokenProvider) {
        super(baseUrl, tokenProvider);
        this.entity = entity;
    }
    async get(id) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: `/api/v1/storage/get`,
            params: {
                entity: this.entity,
                id,
            },
        });
        return response.data;
    }
    async list(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/storage/list',
            data: {
                ...request,
                entity: this.entity,
            },
        });
        return response.data;
    }
    async listColumns(request, ...columns) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/storage/listColumns',
            data: {
                ...request,
                entity: this.entity,
                columns: columns,
            },
        });
        return response.data;
    }
    async listParents(id, includeSelf) {
        const response = await this.axiosInstance({
            method: 'GET',
            url: '/api/v1/storage/listParents',
            params: {
                entity: this.entity,
                id,
                includeSelf,
            },
        });
        return response.data;
    }
    /**
     * Convenience method to get count of rows by filter
     */
    async count(request) {
        const response = await this.list({ filter: request.filter, limit: 0 });
        return response.total;
    }
    async post(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/storage/post',
            data: {
                ...request,
                entity: this.entity,
            },
        });
        return response.data;
    }
    async massCreate(request) {
        let req = request;
        if (Array.isArray(request)) {
            req = {
                items: req.map((data) => ({ data: data })),
            };
        }
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/storage/massCreate',
            data: {
                ...req,
                entity: this.entity,
            },
        });
        return response.data;
    }
    async massUpdate(request) {
        let nullFields = undefined;
        if (request.data) {
            nullFields = [];
            Object.entries(request.data).forEach(([key, value]) => {
                if (value == null) {
                    nullFields.push(key);
                }
            });
        }
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/storage/massUpdate',
            data: {
                ...request,
                entity: this.entity,
                nullFields,
            },
        });
        return response.data;
    }
    async massDelete(request) {
        const response = await this.axiosInstance({
            method: 'POST',
            url: '/api/v1/storage/massDelete',
            data: {
                ...request,
                entity: this.entity,
            },
        });
        return response.data;
    }
}
exports.StorageClient = StorageClient;
